<md-content-box class="enrollment-box">
	<div class="enrollment-info">
		<div class="enrollment-info__header">
			<div class="enrollment-info__title enrollment-info__title--clickable" (click)="viewDetails.emit(enrollment().enrollmentID)">
				<md-header (click)="openLink('enrollment')" size="sm" variant="semibold" [ngClass]="{ clickable: isUserAdmin() }">
					<md-icon icon="untitled-ui/general/translate-01"></md-icon>
					{{ languageName() }}
				</md-header>
				<md-header size="xs" variant="medium">Level {{ enrollment().languageLevels }}</md-header>
				@if (enrollment().programTypeName) {
					<lb-program-type-tag
						variant="modern"
						[program]="enrollment().programName"
						[programType]="enrollment().programTypeName"
					></lb-program-type-tag>
				}
			</div>
			<span class="spacer"></span>
			@if (!isUserInstructor() && isAwaitingSchedule()) {
				<a md-button routerLink="/enrollments/{{ enrollment().enrollmentID }}/schedule">
					<md-icon icon="untitled-ui/time/clock"></md-icon>
					Schedule
				</a>
			}
			<ng-content select="[enrollment-links]"></ng-content>

			@if (enrollment().enrollmentGUID) {
				<lb-external-links [entityGuid]="enrollment().enrollmentGUID" [entityType]="'Enrollment'" [mode]="'compact'"> </lb-external-links>
			}
		</div>
		<div class="program-info">
			<div class="program-info__content">
				@if (userView() === 'instructor') {
					@if (enrollment().instructorUserID && enrollment().enrollmentStatusID !== 3) {
						<div class="instructor-avatar" (click)="openLink('instructor')" [ngClass]="{ clickable: isUserAdmin() }">
							<lb-user-icon [userID]="enrollment().instructorUserID"></lb-user-icon>
							<div class="user-info">
								<div class="name">
									<span class="user-info__top">
										{{ instructor()?.fullName }}
									</span>
									<md-tag type="tertiary">Instructor</md-tag>
									@if (relatedInstitution()) {
										<md-tag type="warning">{{ relatedInstitution() }}</md-tag>
									}
								</div>
								<div>
									@if (instructor()?.username; as instructorEmail) {
										{{ instructorEmail }}
										<lb-copy-to-clipboard [textToCopy]="instructorEmail" [showConfirmation]="true"></lb-copy-to-clipboard>
									}
								</div>
							</div>
						</div>
					} @else {
						<lb-no-instructor />
					}
				} @else {
					@if (showMemberStack()) {
						<!-- Chirp room: the placeholder "learner" is a room, not a person — show who is actually in it. -->
						<div class="instructor-avatar" (click)="openLink('learner')" [ngClass]="{ clickable: isUserAdmin() }">
							<div class="member-stack">
								@for (member of stackedMembers(); track member.enrollmentMemberID) {
									<lb-user-icon class="member-stack__icon" [userID]="member.userID" [title]="memberName(member.userID)"></lb-user-icon>
								}
								@if (stackOverflowCount() > 0) {
									<span class="member-stack__overflow md-text-xs-medium">+{{ stackOverflowCount() }}</span>
								}
							</div>
							<div class="user-info">
								<div class="name">
									<span class="user-info__top">{{ learner()?.fullName }}</span>
									<md-tag type="tertiary"
										>{{ activeRoomMembers().length }} {{ activeRoomMembers().length === 1 ? 'member' : 'members' }}</md-tag
									>
									@if (relatedInstitution()) {
										<md-tag type="warning">{{ relatedInstitution() }}</md-tag>
									}
								</div>
							</div>
						</div>
					} @else {
						<div class="instructor-avatar" (click)="openLink('learner')" [ngClass]="{ clickable: isUserAdmin() }">
							<lb-user-icon [userID]="enrollment().learnerUserID"></lb-user-icon>
							<div class="user-info">
								<div class="name">
									<span class="user-info__top">{{ learner()?.fullName }}</span>
									<md-tag type="tertiary">Learner</md-tag>
									@if (relatedInstitution()) {
										<md-tag type="warning">{{ relatedInstitution() }}</md-tag>
									}
									@for (tag of learnerTags(); track tag.userTagTypeID) {
										<md-tag [type]="tag.tagColor ?? 'warning'">{{ tag.tagTypeName }}</md-tag>
									}
								</div>

								@if (learner()?.username; as learnerEmail) {
									@if (!learnerEmail.includes('@cr.languagebird.com')) {
										<div>
											{{ learnerEmail }}
											<lb-copy-to-clipboard [textToCopy]="learnerEmail" [showConfirmation]="true"></lb-copy-to-clipboard>
										</div>
									}
								}
							</div>
						</div>
					}
				}

				<!-- <div class="program-details">
					<span class="program-details__top">{{ enrollmentHistory().programName }}</span>
					@if (enrollment().languageLevelDisplayName) {
						<span class="program-details__bottom">Level {{ enrollment().languageLevelDisplayName }}</span>
					}
				</div> -->
			</div>
		</div>
		<div class="status-info">
			<div class="status-info__content">
				<div>
					<span>Lesson Times</span>
					@if (timeSlotSelections().length > 0) {
						<div class="chip-container">
							@for (selection of timeSlotSelections(); track $index) {
								<div class="schedule">
									<md-content-box>{{ selection.day.substring(0, 3) }}, {{ selection.displayValue }}</md-content-box>
								</div>
							}
						</div>
					} @else {
						<span class="status-info__placeholder">N/A</span>
					}
				</div>

				<div>
					<span>Status</span>
					<lb-enrollment-tag
						[enrollmentStatus]="enrollment().enrollmentStatusName"
						[enrollmentStatusID]="enrollment().enrollmentStatusID"
						[isLearner]="userView() === 'instructor'"
					></lb-enrollment-tag>
				</div>
				<!-- <div>
					<span>Related Institution</span>
					@if (relatedInstitution()) {
						<span>{{ relatedInstitution() }}</span>
					} @else {
						<span class="status-info__placeholder">-</span>
					}
				</div> -->
			</div>
			<button
				type="button"
				class="status-info__toggle"
				(click)="toggleDetails()"
				[attr.aria-expanded]="detailsExpanded()"
				[attr.aria-controls]="isUserInstructor() ? 'enrollmentDetailsBody' : null"
				[attr.aria-label]="detailsExpanded() ? 'Hide enrollment details' : 'Show enrollment details'"
			>
				<md-icon [ngClass]="{ rotated: detailsExpanded() }" icon="untitled-ui/arrows/chevron-down"></md-icon>
			</button>
		</div>

		@if (detailsExpanded()) {
			@if (showStartDate() || showLastLessonDate() || showLessonFrequency()) {
				<div class="details-section">
					<div class="schedule-info">
						@if (showStartDate()) {
							<div>
								<span>{{ startDateLabel() }}</span>
								<span>{{ startDate() }}</span>
								@if (startDateToBeConfirmed()) {
									<md-tag type="tertiary">Pending Start</md-tag>
								}
							</div>
						}
						@if (showLastLessonDate()) {
							<div>
								<span>{{ endDateLabel() }}</span>
								<span>{{ endDate() }}</span>
							</div>
						}
						@if (showLessonFrequency()) {
							<div>
								<span>Lesson Frequency</span>
								@if (enrollment().lessonFrequency) {
									<span>{{ enrollment().lessonFrequency }} lessons / week</span>
								} @else {
									<span>-</span>
								}
							</div>
						}
					</div>
				</div>
			}

			<div class="details-section">
				<div class="schedule-info">
					@if (showMustStartBy()) {
						<div>
							<span>Must Start By</span>
							<span>{{ enrollment().mustStartBy | date: 'd MMM yyyy' }}</span>
						</div>
					}
					@if (showEnrollmentExpiration()) {
						<div>
							<span>Enrollment Expiration</span>
							<span>{{ enrollment().programExpirationDate | date: 'd MMM yyyy' }}</span>
						</div>
					}
					<div>
						<span>Time Zone</span>
						<span>{{ timeZoneName() || '-' }}</span>
					</div>
					@if (finalGrades().length) {
						<div>
							<span>Final Grades</span>
							<div class="grade-container">
								@for (grade of finalGrades(); track grade.semesterID) {
									<lb-grade-tag [compact]="true" [grade]="grade.gradeName" [categoryName]="grade.levelName"></lb-grade-tag>
								}
							</div>
						</div>
					}
				</div>
			</div>

			@if (isUserInstructor()) {
				<div class="details-section">
					<div id="enrollmentDetailsBody" class="details-section__body">
						<div class="enrollment-notes">
							<div>
								<span>Learning Needs</span>
								<span>{{ learningNeeds() ? learningNeeds().note : '-' }}</span>
							</div>
							<div>
								<span>Language Experience</span>
								<span>{{ languageExperience() ? languageExperience().note : '-' }}</span>
							</div>
						</div>
					</div>
				</div>
			}
		}

		@if (programSummary(); as programSummary) {
			<lb-program-completion-summary [program]="programSummary"> </lb-program-completion-summary>
		}
	</div>
</md-content-box>
